var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusMinusDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0.0000610352,
    width: 1.25,
    height: 6.86092,
    rx: 0.625,
    fill: "#c9c9c9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.00006,
    width: 6.86092,
    height: 1.25,
    rx: 0.625,
    fill: "#c9c9c9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.78125,
    y: 11.7616,
    width: 6.86092,
    height: 1.25,
    rx: 0.625,
    fill: "#c9c9c9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.72266,
    y: 12.307,
    width: 14.6324,
    height: 1.25,
    rx: 0.625,
    transform: "rotate(-45 2.72266 12.307)",
    fill: "#c9c9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMinusDisabled);
export default __webpack_public_path__ + "static/media/plus-minus-disabled.ff8bba7786d85e538f8c67f33b1f1bef.svg";
export { ForwardRef as ReactComponent };